import { useRouter } from 'next/router';

import { Box } from '@mui/material';
import { useTranslation } from 'next-i18next';
import InfiniteScroll from 'react-swr-infinite-scroll';
import useSWR from 'swr';
import useSWRInfinite from 'swr/infinite';

import { Container } from './style';

import courseAPI, { COURSE_END_POINT } from 'src/api/course';
import { LoadingInfiniteScroll } from 'src/components/atoms/loading';
import CoursesCard from 'src/components/molecules/courseCard';
import Heading from 'src/components/molecules/heading';
import { useWindowSize } from 'src/helpers/use';
import { IBreadcrumb, ISectionCoursesPagination, SectionType } from 'src/interfaces';

const Section = () => {
  const { t } = useTranslation('common');
  const router = useRouter();
  const { urlName } = router.query;
  const { width } = useWindowSize();
  const { data: section } = useSWR<ISectionCoursesPagination>(`${COURSE_END_POINT.COURSES_SECTION}/${urlName}`);
  const [INIT_COURSE, COURSE_PER_ROW] = (() => {
    if (width! >= 1150 && width! <= 1700) return [16, 4];
    if (width! >= 1701 && width! <= 1999) return [20, 5];
    if (width! >= 2000) return [24, 6];
    if (width! < 1150) return [15, 5];
    return [1, 1];
  })();
  const swr = useSWRInfinite((pageIndex, previousPageData) => {
    if (previousPageData && !previousPageData.data.items.length) return null;
    const limit = pageIndex === 0 ? INIT_COURSE : COURSE_PER_ROW;
    const offset = (() => {
      if (pageIndex !== 0) return pageIndex === 1 ? INIT_COURSE : limit * (pageIndex - 1) + INIT_COURSE;
      return 0;
    })();
    return `${COURSE_END_POINT.COURSES_SECTION}/${urlName}?limit=${limit}&offset=${offset}`;
  }, courseAPI.fetchCoursesBySection);

  const getSectionName = () => {
    if (section?.type === SectionType.Custom) return `${t('all_courses')}: ${section?.title}`;
    return `${section?.title}${t('all')}`;
  };
  const breadcrumbList: IBreadcrumb[] = [{ description: t('main_page'), url: '/' }, { description: getSectionName() }];

  const headerTitle = getSectionName();

  return (
    <>
      <Heading contentHeight="180px" breadcrumbList={breadcrumbList} headerTitle={headerTitle} isSupportLargeScreen />
      <Container sx={{ mt: '3rem', mb: '2rem' }}>
        <InfiniteScroll
          swr={swr}
          loadingIndicator={<LoadingInfiniteScroll />}
          isReachingEnd={(response) =>
            response.data && response.data[response.data.length - 1].data.items.length < COURSE_PER_ROW
          }
        >
          {(response: { data: ISectionCoursesPagination }) => (
            <Box sx={{ mt: width! < 1150 ? 2 : 0 }}>
              <CoursesCard courses={response?.data.items} />
            </Box>
          )}
        </InfiniteScroll>
      </Container>
    </>
  );
};

export default Section;
